import React from 'react';
import { View, StyleSheet } from 'react-native';
import { CommonProperties, CommonStyles } from '../../styles';
import Icon from '../Icon';
import RowView from '../RowView';
import BaseText from '../BaseText';

const TitleSummaryList = ({ amount, desc, iconName, style }) => {
  return (
    <View style={[styles.travelerBox, style]}>
      <RowView>
        <Icon name={iconName} style={styles.icon} />
        <BaseText style={CommonStyles.body}>{desc}</BaseText>
      </RowView>
      <BaseText style={CommonStyles.body}>{amount}</BaseText>
    </View>
  );
};

const styles = StyleSheet.create({
  travelerBox: {
    backgroundColor: '#f6f6f6',
    flexDirection: 'row',
    justifyContent: 'space-between',
    ...CommonProperties.py2,
    ...CommonProperties.px3,
    ...CommonProperties.borderRadius4,
    alignItems: 'stretch',
  },
  icon: {
    color: '#9c9e9f',
    ...CommonProperties.h3,
    ...CommonProperties.mr3,
  },
});

export default TitleSummaryList;
